import { render, staticRenderFns } from "./documents.revenuedepartment.success.vue?vue&type=template&id=cbf32bee&scoped=true"
import script from "./documents.revenuedepartment.success.vue?vue&type=script&lang=js"
export * from "./documents.revenuedepartment.success.vue?vue&type=script&lang=js"
import style0 from "./documents.revenuedepartment.success.vue?vue&type=style&index=0&id=cbf32bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf32bee",
  null
  
)

export default component.exports